import Vue from "vue";
import Vuex from "vuex";
import AppEnv from "./core/AppEnv";
import { AppConstants, Interfaces, apiService } from "./core/Export";
Vue.use(Vuex);
const today = new Date();
export default new Vuex.Store({
  state: {
    appEnv: new AppEnv(),
    selectedYear: today.getFullYear(),
    selectedMonth: today.getMonth() + 1,
    selectedEmpAdditionalJobId: 0,
    employeesList: new Array<any>(),
    currentSelectedEmployees: new Array<any>(),
    currentEmployee: {},
    employeeAttendViewData: { lines: [], approval: { empApprovalDate: null, empManagerApprovalDate: null, empManagerApprovalName: '' }, canAddAdditionalReasonPortal: null },
    employeeAttendEditData: { days: [] },
    isLeftDrawerOpen: false,
    leftDrawerComponnent: null,
    baseItems: {},
    drawerParams: {},
    hasApprovlas: false,
    noOfApprovals: 0,
    actingManagers: [],
    actingManagerId: 0,
    previousEmployeeIds: [],
    currentActingEmployeeId: 0,
    employeeAdditionalJobs: [],
    employeeAdditionalJobKey: 0,
    canEditMonth: true,
    selectedEmpNominationId: 0,
    employeeStandByEditData: new Array<any>()
  },
  mutations: {
    updateSelectedEmpNominationId(state, data) {
      state.selectedEmpNominationId = data;
    },
    updateCurrentActingEmployeeId(state, data) {
      state.currentActingEmployeeId = data;
    },
    updatePreviousEmployeeIds(state, data) {
      state.previousEmployeeIds = data;
    },
    updateActingManagerId(state, data) {
      state.actingManagerId = data;
    },
    updateActingManagers(state, data) {
      state.actingManagers = data;
    },
    updateNoOfApprovals(state, data) {
      state.noOfApprovals = data;
    },
    updateHasApprovlas(state, data) {
      state.hasApprovlas = data;
    },
    updateSelectedYear(state, data) {
      state.selectedYear = data;
    },
    updateSelectedMonth(state, data) {
      state.selectedMonth = data;
    },
    updateEmployeeAdditionalJobs(state, data) {
      state.employeeAdditionalJobs = data;
    },
    updateEmployeeAdditionalJobKey(state, data) {
      state.employeeAdditionalJobKey = data;
    },
    updateSelectedEmpAdditionalJobId(state, data) {
      state.selectedEmpAdditionalJobId = data;
      state.appEnv.setAdditionalJob(state.selectedEmpAdditionalJobId);
    },
    updateEmployeesList(state, data) {
      state.employeesList = data;
    },
    updateCurrentEmployee(state, data) {
      state.currentEmployee = data;
    },
    updateCurrentSelectedEmployees(state, data) {
      state.currentSelectedEmployees = data;
    },
    updateEmployeeAttendViewData(state, data) {
      state.employeeAttendViewData = data;
    },
    updateEmployeeAttendEditData(state, data) {
      state.employeeAttendEditData = data;
    },
    updateIsLeftDrawerOpen(state, data) {
      state.isLeftDrawerOpen = data;
    },
    updateLeftDrawerComponnent(state, data) {
      state.leftDrawerComponnent = data;
    },
    updateBaseItems(state, data) {
      state.baseItems[data.key] = data.values;
    },
    updateDrawerParams(state, data) {
      state.drawerParams = data;
    },
    updateCanEditMonth(state, data) {
      state.canEditMonth = data;
    },
    updateEmployeeStandByEditData(state, data) {
      state.employeeStandByEditData = data;
    }
  },
  actions: {
    reduceApprovalsCount(state, data) {
      if (state.getters.noOfApprovals == 0) {
        state.commit(AppConstants.StoreMutations.UpdateHasApprovlas, false);
      } else {
        let noOfApprovals = state.getters.noOfApprovals - 1;
        state.commit(AppConstants.StoreMutations.UpdateNoOfApprovals, noOfApprovals);
      }
    },
    async getEmployeePortalMin(state, data): Promise<any> {
      try {
        let date: any = null;
        if (data && data.hasOwnProperty("date")) date = data.date;
        state.state.appEnv.isBusy = true;
        let res = await apiService.getEmployeePortalMin(state.state.currentEmployee["id"], date, state.state.selectedYear, state.state.selectedMonth);
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          return call.callResult.dto;
        } else {
          state.state.appEnv.showErrorDialog(call.msgs.msgs);
        }
        return null;
      } catch (error) {
        return null;
      }
      finally {
        state.state.appEnv.isBusy = false;
      }
    },
    getEmployeeMonthAttendViewData(state, data) {
      let forceCalc = false;
      if (data && data.hasOwnProperty("forceCalc")) forceCalc = data.forceCalc;
      state.state.appEnv.isBusy = true;
      return apiService
        .getEmployeeMonthAttend(
          state.state.currentEmployee["id"],
          state.state.selectedYear,
          state.state.selectedMonth,
          forceCalc,
          state.state.currentEmployee["salaryFactoryNo"],
          state.state.selectedEmpNominationId
        )
        .then((res) => {
          let result = res as Interfaces.iServiceRequest;
          let call = result.calls[0] as Interfaces.iServiceCall;
          if (call && call.isSuccess) {
            let viewData = call.callResult.data;
            state.commit(AppConstants.StoreMutations.UpdateEmployeeAttendViewData, viewData);
            state.commit(AppConstants.StoreMutations.UpdateCanEditMonth, viewData.canEditMonth);
          } else {
            state.state.appEnv.showErrorDialog(call.msgs.msgs);
          }
        })
        .catch(err => {
        })
        .finally(() => {
          state.state.appEnv.isBusy = false;
        });
    },
    getEmployeeMonthAttendEditData(state, data) {
      state.state.appEnv.isBusy = true;
      apiService
        .getNewEmployeeAttendMonthEntry(
          state.state.currentEmployee["id"],
          state.state.selectedYear,
          state.state.selectedMonth,
          state.state.currentEmployee["salaryFactoryNo"],
          state.state.selectedEmpNominationId
        )
        .then(res => {
          let result = res as Interfaces.iServiceRequest;
          let call = result.calls[0] as Interfaces.iServiceCall;
          if (call && call.isSuccess) {
            state.commit(
              AppConstants.StoreMutations.UpdateEmployeeAttendEditData,
              call.callResult.data
            );
          } else {
            state.state.appEnv.showErrorDialog(call.msgs.msgs);
            state.commit(
              AppConstants.StoreMutations.UpdateEmployeeAttendEditData,
              []
            );
          }
          state.state.appEnv.isBusy = false;
        })
        .catch(err => {
          state.state.appEnv.isBusy = false;
        });
    },
    getEmployeeStandByEditData(state, data) {
      state.state.appEnv.isBusy = true;
      apiService
        .getList(AppConstants.Entites.EmployeeStandby)
        .then(res => {
          let result = res as Interfaces.iServiceRequest;
          let call = result.calls[0] as Interfaces.iServiceCall;
          if (call && call.isSuccess) {
            let data = call.callResult;
            state.commit(AppConstants.StoreMutations.UpdateEmployeeStandByEditData, data);
          } else {
            state.state.appEnv.showErrorDialog(call.msgs.msgs);
            state.commit(
              AppConstants.StoreMutations.UpdateEmployeeStandByEditData,
              []
            );
          }
        })
        .catch(err => {
        }).finally(() => {
          state.state.appEnv.isBusy = false;
        })
    },

    getBaseItem(state, type) {
      let baseItem = state.state.baseItems[type];
      if (baseItem && baseItem.length > 0) return;
      state.state.appEnv.isBusy = true;
      apiService
        .getBaseItem(type)
        .then(res => {
          let result = res as Interfaces.iServiceRequest;
          let call = result.calls[0] as Interfaces.iServiceCall;
          if (call && call.isSuccess) {
            state.commit(AppConstants.StoreMutations.UpdateBaseItems, {
              key: type,
              values: call.callResult.data
            });
          } else {
            state.state.appEnv.showErrorDialog(call.msgs.msgs);
          }
          state.state.appEnv.isBusy = false;
        })
        .catch(err => {
          state.state.appEnv.isBusy = false;
        });
    }
  },
  getters: {
    selectedEmpNominationId(state) {
      return state.selectedEmpNominationId;
    },
    canEditMonth(state) {
      return state.canEditMonth;
    },
    currentActingEmployeeId(state) {
      return state.currentActingEmployeeId;
    },
    previousEmployeeIds(state) {
      return state.previousEmployeeIds;
    },
    actingManagerId(state) {
      return state.actingManagerId;
    },
    actingManagers(state) {
      return state.actingManagers;
    },
    noOfApprovals(state) {
      return state.noOfApprovals;
    },
    hasApprovlas(state) {
      return state.noOfApprovals;
    },
    drawerParams(state) {
      return state.drawerParams;
    },
    baseItems(state) {
      return state.baseItems;
    },
    leftDrawerComponnent(state) {
      return state.leftDrawerComponnent;
    },
    isLeftDrawerOpen(state) {
      return state.isLeftDrawerOpen;
    },
    employeeAttendEditData(state) {
      return state.employeeAttendEditData;
    },
    employeeAttendViewData(state) {
      return state.employeeAttendViewData;
    },
    currentSelectedEmployees(state) {
      return state.currentSelectedEmployees;
    },
    currentEmployee(state) {
      return state.currentEmployee;
    },
    employeesList(state) {
      return state.employeesList;
    },
    selectedYear(state) {
      return state.selectedYear;
    },
    selectedEmpAdditionalJobId(state) {
      return state.selectedEmpAdditionalJobId;
    },
    employeeAdditionalJobs(state) {
      return state.employeeAdditionalJobs;
    },
    employeeAdditionalJobKey(state) {
      return state.employeeAdditionalJobKey;
    },
    selectedMonth(state) {
      return state.selectedMonth;
    },
    appEnv(state) {
      return state.appEnv;
    },
    employeeStandByEditData(state) {
      return state.employeeStandByEditData;
    }
  }
});
